/**
 * Helpers for muusa.auth0.com browser redirect
 */

/**
 * Login return url. Which path the auth backend should redirect to.
 * Info pages should return to root.
 */
export const loginReturnUrl = function (returnUrl) {
    return returnUrl
        || (process.client && window.location.pathname)
        || '/';
};

/**
 * Logout return url.
 * Base href (protocol, domain, tld) is added in the html index template.
 */
export const logoutReturnUrl = function () {
    return '/loggedout';
};

export const loginUrl = function (returnUrl) {
    return `/svc/auth/auth0?ReturnUrl=${loginReturnUrl(returnUrl)}`;
};

export const logoutUrl = function () {
    return `/svc/auth/logout?ReturnUrl=${logoutReturnUrl()}`;
};

/**
 * Register url, will lead to auth0. No ReturnUrl (to /verifyemail) needed here.
 */
export const registerUrl = function () {
    return `/svc/auth/auth0?screen_hint=signup`;
};

export const register = function () {
    const url = registerUrl();
    if (process.client) {
        // push Mouseflow event
        // pushMFQ(["setVariable", "register", true]);
        // pushMFQ(["tag", "register-started"]);

        // open url
        window.location.assign(url);
    }
};
